<template>
  <div class="page-content">
    

    <v-card class="mx-auto elevation-2 tabs-card" style="margin-top: 16px;">
      <v-container fluid class="pa-2">
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="auto">
            <v-tabs 
              v-model="activeTab" 
              class="dashboard-tab" 
              show-arrows 
              next-icon="mdi-arrow-right-bold-box-outline" 
              prev-icon="mdi-arrow-left-bold-box-outline"
              style="background-color: white; color: #2C74B3;"
            >
              <v-tab value="studio">Studio</v-tab>
              <v-tab value="morning">Morning</v-tab>
              <v-tab value="evening">Evening</v-tab>
              <v-tab value="night">Night</v-tab>
              <v-tab value="satellite">Satellite</v-tab>
              <v-tab value="lata">Lata</v-tab>
              <v-tab value="active">Active</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- New Cards Section -->
    <v-row style="margin-top: 10px;">
      <!-- View Model Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'viewModel' ? 'active-card' : '']" @click="setActiveCard('viewModel')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-dance-pole</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">View Model</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-select
              v-model="modelFilter"
              :items="models"
              item-title="fullName"
              item-value="fullName"
              label="Select Model"
              outlined
              hide-details
              prepend-inner-icon=""
              style="font-size: 14px;"
            ></v-select>
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'viewModel' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;" @click="viewModel">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Search Adjustments Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'searchAdjustments' ? 'active-card' : '']" @click="setActiveCard('searchAdjustments')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-text-box-search-outline</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">Search Adjustments</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-text-field
              v-model="searchKeyword"
              label="Description"
              outlined
              hide-details
              dense
              prepend-inner-icon=""
              style="font-size: 14px;"
            />
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'searchAdjustments' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;" @click="searchAdjustments">Search</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- View Filter Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'viewFilter' ? 'active-card' : '']" @click="setActiveCard('viewFilter')" style="max-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-filter</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">View Filter</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; justify-items: center;">
              <v-chip
                v-for="filter in filterOptions"
                :key="filter"
                :color="activeFilters.includes(filter) ? '#1976d2' : '#ccc'"
                text-color="white"
                @click="toggleFilter(filter)"
                style="font-size: 14px; cursor: pointer; min-width: 120px; justify-content: center;"
              >
                {{ filter }}
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Period Card -->
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'period' ? 'active-card' : '']" @click="setActiveCard('period')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-calendar-multiple-check</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">Period</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px;">
            <v-select 
              v-model="selectedPeriod" 
              :items="periods" 
              item-title="name" 
              item-value="id" 
              outlined 
              style="font-size: 14px;" 
              @update:modelValue="fetchModels"
            ></v-select>
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn 
              :class="['btn-secondary', activeCard === 'period' ? 'active-button' : '']" 
              style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;" 
              @click="viewPeriod" 
              :disabled="!selectedPeriod"
            >
              View
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Chips Below Cards -->
    <v-row style="margin-top: 16px;" v-if="selectedModels.length > 0">
      <v-col cols="12">
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <v-chip
            v-for="modelName in selectedModels"
            :key="modelName"
            closable
            @click:close="removeModelChip(modelName)"
            color="#1976d2"
            text-color="white"
            style="font-size: 14px;"
          >
            {{ modelName }}
          </v-chip>
        </div>
      </v-col>
    </v-row>

    <!-- Divider Bar -->
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; height: 48px; background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%); color: white; border-radius: 6px; margin-top: 28px;">
      <h2 style="font-size: 18px; font-weight: 600; color: white;">Adjustments</h2>
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
                          style="text-transform: none; font-size: 1rem; background-color: transparent; color: white;"
          >
            <span style="font-weight: 400; margin-right: 4px;">Sort by:</span>
            {{ sortOption }}
            <v-icon small style="color: white;">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            density="compact"
            v-for="option in sortOptions"
            :key="option"
            @click="sortModels(option)"
          >
            <v-list-item-title>{{ option }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-container fluid class="pa-0 mt-4">
      <v-row>
        <v-col v-for="(model, modelIndex) in filteredModels" :key="model.id" cols="12">
          <!-- Existing model card content remains unchanged -->
          <v-card class="elevation-3" style="border-radius: 6px; padding: 0; margin-bottom: 16px;">
            <v-container fluid class="pa-2" style="padding: 5px 5px 5px 5px !important;">
              <v-row no-gutters align="center" dense style="margin-top: 4px; margin-bottom: 0 !important;">
                <v-col cols="5">
                  <v-text-field
                    v-model="model.fullName"
                    variant="outlined"
                    persistent-placeholder
                    label="Full Name"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="3" class="pl-2">
                  <v-text-field
                    v-model="model.stageName"
                    variant="outlined"
                    persistent-placeholder
                    label="Stage Name"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="1.5" class="pl-2">
                  <v-text-field
                    v-model.number="model.classes"
                    type="number"
                    variant="outlined"
                    persistent-placeholder
                    label="Classes"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    :disabled="isPeriodLocked"
                    @keypress="restrictToNumbers($event)"
                    @input="debounceSave(model.id)"
                  ></v-text-field>
                </v-col>
                <v-col cols="1.5" class="pl-2">
                  <v-select
                    v-model="model.subsidy"
                    :items="subsidyOptions"
                    variant="outlined"
                    persistent-placeholder
                    label="Subsidy"
                    hide-details
                    density="compact"
                    style="margin-bottom: 0 !important; height: 34px !important; font-weight: bold !important; font-size: 16px !important;"
                    :disabled="isPeriodLocked"
                    @update:modelValue="debounceSave(model.id)"
                  ></v-select>
                </v-col>
                <v-col cols="1" class="pl-2 text-center">
                  <v-btn 
                    icon 
                    class="btn-primary" 
                    density="comfortable" 
                    @click="addAdjustment(modelIndex)"
                    :disabled="isPeriodLocked"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-container
              v-if="!(model.adjustments && model.adjustments.length > 0)"
              fluid
              class="pa-2"
              style="padding-bottom: 0px !important;"
            >
            </v-container>

            <div v-if="model.adjustments && model.adjustments.length > 0">
              <v-divider style="border-color: #e0e0e0; margin: 0;"></v-divider>
              <v-container
                fluid
                class="pa-2"
                :style="{
                  padding: '5px 5px 0px 5px !important',
                  maxHeight: model.isExpanded ? 'none' : '400px',
                  overflowY: model.isExpanded ? 'visible' : 'auto'
                }"
              >
                <v-row no-gutters dense style="margin: -5px 0 -7px 0 !important; padding: 0 !important;">
                  <v-col cols="12">
                    <v-row no-gutters align="center">
                      <v-col style="flex: 0 0 13%; max-width: 13%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Type</span>
                      </v-col>
                      <v-col style="flex: 0 0 13%; max-width: 13%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Amount</span>
                      </v-col>
                      <v-col style="flex: 0 0 9%; max-width: 9%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Xe</span>
                      </v-col>
                      <v-col style="flex: 0 0 33%; max-width: 33%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Description</span>
                      </v-col>
                      <v-col style="flex: 0 0 7%; max-width: 7%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">#</span>
                      </v-col>
                      <v-col style="flex: 0 0 8%; max-width: 8%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Quotas</span>
                      </v-col>
                      <v-col style="flex: 0 0 10%; max-width: 10%; padding-left: 6px;">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Date</span>
                      </v-col>
                      <v-col style="flex: 0 0 7%; max-width: 7%; padding-left: 0px;" class="text-center">
                        <span style="font-size: 12px; font-weight: 600; color: #707070;">Actions</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-data-table
                  :items="model.adjustments"
                  class="elevation-0"
                  hide-default-footer
                  hide-default-header
                  density="compact"
                  :items-per-page="-1"
                  style="background-color: white; padding: 0 !important; margin: 0 !important;"
                >
                  <template v-slot:item="{ item, index: adjIndex }">
                    <tr :style="{
                      backgroundColor: item.insufficientFunds ? '#fff2f2' : 'transparent',
                      borderBottom: 'none'
                    }">
                      <td :style="{ width: '13%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.type"
                          :items="['Purchase', 'Discount', 'Adjustment', 'Bonus']"
                          :item-title="t => t"
                          :item-value="t => t"
                          :style="{
                            color: 'black',
                            borderLeft: ['Purchase', 'Discount'].includes(item.type) ? '2px solid #ff1744' : '2px solid #8CDA4D'
                          }"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px; width: 100%;"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          @update:modelValue="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-select>
                      </td>
                      <td :style="{ width: '13%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-text-field
                          v-model="item.amount"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :rules="[v => /^[0-9.]*$/.test(v) || 'Only numbers and one decimal allowed']"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          @blur="formatAmount(item)"
                          @input="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-text-field>
                      </td>
                      <td :style="{ width: '9%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.currency"
                          :items="currencyOptions"
                          :item-title="c => c"
                          :item-value="c => c"
                          :style="{
                            color: 'black',
                            borderLeft: item.currency === 'COP' ? '2px solid #fbc02d' :
                                        item.currency === 'USD' ? '2px solid #74B341' :
                                        item.currency === 'EUR' ? '2px solid #1e88e5' : '2px solid #ccc'
                          }"
                          density="compact"
                          hide-details
                          style="height: 30px !important; font-size: 14px; width: 100%;"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          @update:modelValue="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-select>
                      </td>
                      <td :style="{ width: '33%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-text-field
                          v-model="item.description"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          @input="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-text-field>
                      </td>
                      <td :style="{ width: '7%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.number"
                          :items="numberOptions"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          @update:modelValue="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-select>
                      </td>
                      <td :style="{ width: '8%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-select
                          v-model="item.quotas"
                          :items="numberOptions"
                          density="compact"
                          outlined
                          hide-details
                          style="height: 30px !important; font-size: 14px;"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          @update:modelValue="markAdjustmentAsEdited(model.id, adjIndex)"
                        ></v-select>
                      </td>
                      <td :style="{ width: '10%', opacity: (item.nextPeriod || item.insufficientFunds) ? 0.5 : 1, padding: '0 2px !important', borderBottom: 'none !important' }">
                        <v-date-input
                          v-model="item.date"
                          @update:modelValue="updateDateValue(modelIndex, adjIndex, $event); markAdjustmentAsEdited(model.id, adjIndex)"
                          prepend-icon=""
                          hide-details
                          density="compact"
                          :disabled="isPeriodLocked || item.nextPeriod"
                          :menu-props="{ closeOnContentClick: true, offsetY: true, closeOnSelect: true }"
                          hide-actions
                          placeholder="YYYY-MM-DD"
                          style="height: 30px !important; font-size: 14px;"
                        ></v-date-input>
                      </td>
                      <td class="text-center btn-primary" style="width: 7%; padding: 10px 0 0 0 !important; border-bottom: none !important; opacity: 1 !important; pointer-events: auto;">
                        <v-btn 
                          icon 
                          class="btn-primary" 
                          density="comfortable" 
                          :disabled="isPeriodLocked"
                          @click="item.isNew || item.isEdited ? saveAdjustment(model.id, adjIndex) : openActionDialog(modelIndex, adjIndex)"
                        >
                          <div
                            :style="item.observation ? {
                              border: '3px solid #2196F3',
                              borderRadius: '50%',
                              padding: '5px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            } : {}"
                          >
                            <v-icon size="small" :color="item.isNew || item.isEdited ? 'blue' : 'black'">
                              {{ item.isNew || item.isEdited ? 'mdi-content-save' : 'mdi-dots-horizontal' }}
                            </v-icon>
                          </div>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-container>

              <v-row no-gutters style="position: relative; height: 12px; padding: 0;" justify="end" align="start">
                <v-col cols="auto" style="position: absolute; bottom: -10px; right: -8px; display: flex; align-items: center; justify-content: flex-end; padding: 0; margin: 0;">
                  <v-btn
                    icon
                    variant="plain"
                    size="small"
                    @click="toggleExpand(modelIndex)"
                    style="margin: 0 !important; min-width: 0 !important; padding: 0 !important;"
                  >
                    <v-icon class="mdi-rotate-90" size="12" color="black" style="margin: 0 !important;">
                      mdi-arrow-expand
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Add Model</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="searchQuery"
            label="Search by Name or Stage Name"
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
            density="compact"
            :disabled="isPeriodLocked"
            @input="fetchAvailableModels"
          ></v-text-field>
          <v-list>
            <v-list-item v-for="model in filteredAvailableModels" :key="model.id" @click="selectModel(model.id)">
              <v-list-item-title>{{ model.fullName }} ({{ model.stageName }})</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="actionDialog" :max-width="600" :max-height="380" content-class="small-dialog">
      <v-card class="pa-3">
        <v-card-text class="pa-0">
          <v-row justify="space-between" align="start">
            <v-col cols="6">
              <div style="font-weight: bold; font-size: 14px;">
                {{ filteredModels[selectedModelIndex]?.fullName }}
              </div>
              <div style="color: #2C74B3; font-weight: 500; font-size: 13px;">
                {{ filteredModels[selectedModelIndex]?.stageName }}
              </div>
            </v-col>
            <v-col cols="6" class="text-right">
              <div style="font-size: 13px;">
                <strong>{{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.type }}</strong>
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.amount }}
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.currency }}
              </div>
              <div style="font-size: 13px; color: #707070;">
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.number }}/{{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.quotas }}
              </div>
            </v-col>
          </v-row>

          <v-row dense align="center" justify="space-around">
            <v-col class="text-center">
              <div class="mb-1" style="font-weight: 500;">Next Period</div>
              <v-btn 
                icon 
                @click="sendToNextPeriod(selectedModelIndex, selectedAdjIndex)"
                :disabled="isPeriodLocked"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <div class="mb-1" style="font-weight: 500;">Insufficient Funds</div>
              <v-btn 
                icon 
                @click="toggleInsufficientFunds(selectedModelIndex, selectedAdjIndex)"
                :disabled="isPeriodLocked"
              >
                <v-icon>mdi-currency-usd-off</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <div class="mb-1" style="font-weight: 500;">Delete</div>
              <v-btn 
                icon 
                @click="removeAdjustment(selectedModelIndex, selectedAdjIndex)"
                :disabled="isPeriodLocked"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div style="font-style: regular; font-size: 13px;">
                {{ filteredModels[selectedModelIndex]?.adjustments?.[selectedAdjIndex]?.description }}
              </div>
            </v-col>
          </v-row>
          <v-textarea
            v-model="editingAdjustment.observation"
            label="Observation"
            outlined
            rows="2"
            auto-grow
            :disabled="isPeriodLocked"
          />
        </v-card-text>
        <v-card-actions class="pa-0" style="padding-top: 0; margin-top: -25px; margin-bottom: -15px; display: flex; justify-content: flex-end; gap: 12px;">
          <v-btn variant="plain" dense @click="closeDialog">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>












<script>
import secureAxios from '@/utils/secureAxios';
import { toast } from 'vue3-toastify';
import debounce from 'lodash/debounce';

export default {
  data() {
    return {
      activeTab: "studio",
      selectedPeriod: null,
      periods: [],
      models: [],
      subsidyOptions: ['Full', 'Half', 'None'],
      currencyOptions: ["USD", "COP", "EUR"],
      numberOptions: [1, 2, 3, 4, 5, 6],
      dialog: false,
      searchQuery: '',
      availableModels: [],
      isSaving: false,
      actionDialog: false,
      selectedModelIndex: null,
      selectedAdjIndex: null,
      editingAdjustment: {},
      isPeriodLocked: false,
      activeCard: null,
      modelFilter: null,
      selectedModels: [],
      filterOptions: ['Classes', 'Subsidy', 'Discounts', 'Purchases', 'Adjustments', 'Bonuses'],
      activeFilters: [],
      sortOptions: ['Full Name A → Z', 'Full Name Z → A', 'Stage Name A → Z', 'Stage Name Z → A'],
      sortOption: 'Full Name A → Z',
      searchKeyword: '',
    };
  },
  computed: {
    // Same as your original computed properties
    filteredModels() {
      let filtered = [...this.models];
      console.log('Filtering models for tab:', this.activeTab, 'Total models:', filtered.length);

      filtered = filtered.filter(model => {
        const hasAdjustments = model.adjustments?.length > 0 || model.classes > 0 || model.subsidy !== 'None';
        const isActive = model.status.toUpperCase() === 'ACTIVE';

        if (hasAdjustments) return true;

        if (isActive) {
          switch (this.activeTab) {
            case 'studio':
              return ['Morning', 'Evening', 'Night'].includes(model.location);
            case 'morning':
              return model.location === 'Morning';
            case 'evening':
              return model.location === 'Evening';
            case 'night':
              return model.location === 'Night';
            case 'satellite':
              return model.location === 'Satellite';
            case 'lata':
              return model.location === 'Lata';
            case 'active':
              return true;
            default:
              return true;
          }
        }

        return false;
      });

      if (this.selectedModels.length > 0) {
        filtered = filtered.filter(model =>
          this.selectedModels.includes(model.fullName)
        );
      }

      if (this.activeFilters.length > 0) {
        filtered = filtered.map(model => {
          const hasClassFilter = this.activeFilters.includes('Classes') && model.classes > 0;
          const hasSubsidyFilter = this.activeFilters.includes('Subsidy') && model.subsidy !== 'None';
          const selectedTypesMap = {
            Discount: 'Discounts',
            Purchase: 'Purchases',
            Adjustment: 'Adjustments',
            Bonus: 'Bonuses'
          };
          const selectedTypes = Object.keys(selectedTypesMap).filter(type =>
            this.activeFilters.includes(selectedTypesMap[type])
          );
          const matchingAdjustments = model.adjustments?.filter(adj =>
            selectedTypes.includes(adj.type)
          ) || [];
          const match =
            hasClassFilter ||
            hasSubsidyFilter ||
            (selectedTypes.length > 0 && matchingAdjustments.length > 0);
          return match
            ? { ...model, adjustments: selectedTypes.length > 0 ? matchingAdjustments : model.adjustments }
            : null;
        }).filter(Boolean);
      }

      const sortField = this.sortOption.includes('Full Name') ? 'fullName' : 'stageName';
      const direction = this.sortOption.includes('Z → A') ? -1 : 1;
      filtered.sort((a, b) => a[sortField].toLowerCase().localeCompare(b[sortField].toLowerCase()) * direction);

      return filtered;
    },
    filteredAvailableModels() {
      const filtered = this.availableModels.filter(model =>
        model.fullName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        model.stageName.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      return filtered;
    },
  },
  methods: {
    debounceSave: debounce(function(modelId) {
      this.saveAdjustments(modelId);
    }, 1000), // 1-second debounce
    stringToDate(dateStr) {
      if (!dateStr || typeof dateStr !== 'string') return new Date();
      const [year, month, day] = dateStr.split('-').map(Number);
      if (!year || !month || !day) return new Date();
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? new Date() : date;
    },
    dateToString(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return new Date().toISOString().split('T')[0];
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    updateDateValue(modelIndex, adjIndex, dateValue) {
      const id = this.filteredModels[modelIndex].id;
      const index = this.findModelIndex(id);
      if (index === -1) return;
      const dateObj = new Date(dateValue);
      this.models[index].adjustments[adjIndex].date = dateObj;
    },
    formatAmount(item) {
      let value = item.amount || '';
      if (!value) {
        item.amount = item.currency === 'COP' ? '0' : '0.00';
        return;
      }
      value = value.replace(/[^0-9.]/g, '');
      if (item.currency === 'COP') {
        const parts = value.replace(/,/g, '').split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1] ? `.${parts[1].slice(0, 2)}` : '';
        item.amount = `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${decimalPart}`;
      } else {
        const parts = value.split('.');
        const integerPart = parts[0].replace(/\D/g, '');
        const decimalPart = parts[1] ? parts[1].slice(0, 2).replace(/\D/g, '') : '';
        item.amount = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
      }
    },
    parseAmountForSave(value, currency) {
      if (!value) return 0;
      return currency === 'COP' ? parseFloat(value.replace(/,/g, '')) || 0 : parseFloat(value) || 0;
    },
    async fetchPeriods() {
      try {
        const response = await secureAxios.get('/api/adjustments/periods');
        this.periods = response.data;
        this.periods.sort((a, b) => new Date(a.payment_date) - new Date(b.payment_date));
        const today = new Date();
        const currentPeriod = this.periods.find(period => today <= new Date(period.payment_date)) || this.periods[this.periods.length - 1];
        this.selectedPeriod = currentPeriod ? currentPeriod.id : this.periods[0]?.id;
        await this.fetchModels();
      } catch (error) {
        console.error('❌ Error fetching periods:', error);
        toast.error('Failed to fetch periods');
      }
    },
    async fetchModels() {
      if (!this.selectedPeriod) return;
      try {
        const response = await secureAxios.get('/api/adjustments/models', {
          params: { periodId: this.selectedPeriod }
        });
        this.models = response.data.models.map(model => ({
          id: model.id,
          adjustments_id: model.adjustments_id,
          fullName: model.fullName || 'Unknown',
          stageName: model.stageName || '',
          location: model.location || 'Unknown',
          status: model.status || 'Inactive',
          classes: parseInt(model.classes) || 0,
          subsidy: model.subsidy || "None",
          adjustments: (model.adjustments || []).map(adj => ({
            id: adj.id,
            type: adj.type,
            amount: adj.currency === 'COP' 
              ? (parseFloat(adj.amount) || 0).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
              : (parseFloat(adj.amount) || 0).toFixed(2),
            currency: adj.currency,
            description: adj.description || '',
            number: parseInt(adj.number) || 1,
            quotas: parseInt(adj.quotas) || 1,
            date: this.stringToDate(adj.date),
            observation: adj.observation || '',
            nextPeriod: Boolean(adj.nextPeriod),
            insufficientFunds: Boolean(adj.insufficientFunds),
            isNew: false,
            isEdited: false
          })).sort((a, b) => new Date(a.date) - new Date(b.date)),
          isExpanded: false
        }));
        this.isPeriodLocked = response.data.isLocked;
        this.isAdmin = response.data.isAdmin || false;
      } catch (error) {
        console.error('❌ Error fetching models:', error);
        toast.error('Failed to fetch models');
      }
    },
    findModelIndex(id) {
      return this.models.findIndex(m => m.id === id);
    },
    async saveAdjustments(modelId) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot save adjustments');
        return;
      }
      const index = this.findModelIndex(modelId);
      if (index === -1) return;

      const model = this.models[index];
      const payload = {
        period_id: this.selectedPeriod,
        classes: model.classes,
        subsidy: model.subsidy,
        adjustments: model.adjustments.map(adj => ({
          id: adj.id,
          type: adj.type,
          amount: this.parseAmountForSave(adj.amount, adj.currency),
          currency: adj.currency,
          description: adj.description,
          number: adj.number,
          quotas: adj.quotas,
          date: this.dateToString(adj.date),
          observation: adj.observation || '',
          nextPeriod: adj.nextPeriod || false,
          insufficientFunds: adj.insufficientFunds || false
        }))
      };

      this.isSaving = true;
      console.log('Saving adjustments for model:', modelId, JSON.stringify(payload, null, 2));
      
      try {
        const response = await secureAxios.put(`/api/adjustments/models/${modelId}`, payload);
        console.log(`✅ Adjustments saved for model ${modelId}:`, response.data);
        toast.success(`Adjustments saved for ${model.stageName}`);
        model.adjustments.forEach(adj => {
          adj.isNew = false;
          adj.isEdited = false;
        });
      } catch (error) {
        console.error('❌ Error saving adjustments:', error);
        const errMsg = error?.response?.data || error?.message || 'Unknown error';
        toast.error(`Error saving adjustments: ${errMsg}`);
      } finally {
        this.isSaving = false;
      }
    },
    async saveAdjustment(modelId, adjIndex) {
      const index = this.findModelIndex(modelId);
      if (index === -1) return;
      await this.saveAdjustments(modelId);
    },
    markAdjustmentAsEdited(modelId, adjIndex) {
      const index = this.findModelIndex(modelId);
      if (index === -1) return;
      const adjustment = this.models[index].adjustments[adjIndex];
      if (!adjustment.isNew) {
        adjustment.isEdited = true;
      }
    },
    restrictToNumbers(event) {
      const allowedKeys = [8, 46, 37, 38, 39, 40];
      const charCode = event.charCode || event.keyCode;
      if (charCode !== 0 && !allowedKeys.includes(charCode) && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    async addAdjustment(modelIndex) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot add adjustments');
        return;
      }
      if (this.filteredModels[modelIndex].adjustments.length >= 30) {
        toast.error("Maximum of 30 adjustment lines reached for this model.");
        return;
      }
      
      const id = this.filteredModels[modelIndex].id;
      const index = this.findModelIndex(id);
      if (index === -1) return;

      const newAdjustment = {
        type: "Purchase",
        amount: '0',
        currency: "COP",
        description: "",
        number: 1,
        quotas: 1,
        date: new Date(),
        isNew: true,
        isEdited: false,
        nextPeriod: false,
        insufficientFunds: false
      };

      this.models[index].adjustments.push(newAdjustment);
    },
    searchAdjustments() {
      if (!this.searchKeyword) return;
      const keyword = this.searchKeyword.toLowerCase();
      const matches = this.models.filter(model =>
        model.adjustments?.some(adj => adj.description.toLowerCase().includes(keyword))
      );
      this.selectedModels = matches.map(m => m.fullName);
      this.activeTab = 'active';
    },
    async fetchAvailableModels() {
      try {
        const response = await secureAxios.get('/api/adjustments/models/active', {
          params: { periodId: this.selectedPeriod }
        });
        this.availableModels = response.data.map(model => ({
          id: model.id,
          fullName: model.fullName,
          stageName: model.stageName
        }));
      } catch (error) {
        console.error('❌ Error fetching available models:', error);
        toast.error('Failed to fetch available models');
      }
    },
    async selectModel(modelId) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot add models');
        return;
      }
      const payload = {
        model_id: modelId,
        period_id: this.selectedPeriod,
        classes: 0,
        subsidy: 'None'
      };
      try {
        await secureAxios.post('/api/adjustments/models', payload);
        toast.success(`Model ${modelId} added successfully`);
        this.dialog = false;
        this.searchQuery = '';
        await this.fetchModels();
      } catch (error) {
        console.error('❌ Error adding model:', error);
        toast.error('Failed to add model');
      }
    },
    openActionDialog(modelIndex, adjIndex) {
      this.selectedModelIndex = modelIndex;
      this.selectedAdjIndex = adjIndex;
      const model = this.filteredModels[modelIndex];
      const adj = model.adjustments[adjIndex];
      this.editingAdjustment = JSON.parse(JSON.stringify(adj));
      this.actionDialog = true;
    },
    removeAdjustment(modelIndex, adjIndex) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot remove adjustments');
        return;
      }
      const id = this.filteredModels[modelIndex].id;
      const index = this.findModelIndex(id);
      if (index === -1) return;

      this.models[index].adjustments.splice(adjIndex, 1);
      this.actionDialog = false;
      this.debounceSave(id);
    },
    async sendToNextPeriod(modelIndex, adjIndex) {
      if (this.isPeriodLocked) {
        toast.error('Period is locked, cannot modify adjustments');
        return;
      }
      const currentPeriodIndex = this.periods.findIndex(p => p.id === this.selectedPeriod);
      if (currentPeriodIndex === -1 || currentPeriodIndex === this.periods.length - 1) {
        toast.error('No next period available');
        this.actionDialog = false;
        return;
      }

      const nextPeriod = this.periods[currentPeriodIndex + 1];
      const model = this.filteredModels[modelIndex];
      const index = this.findModelIndex(model.id);
      if (index === -1) return;

      const adj = { ...model.adjustments[adjIndex] };
      adj.date = this.dateToString(adj.date);
      adj.amount = this.parseAmountForSave(adj.amount, adj.currency);
      delete adj.id; // New adjustment in next period
      delete adj.isNew;
      delete adj.isEdited;
      delete adj.nextPeriod; // Reset for next period
      delete adj.insufficientFunds;

      try {
        // Check if model exists in next period
        const response = await secureAxios.get('/api/adjustments/models', {
          params: { periodId: nextPeriod.id }
        });
        const nextModels = response.data.models;
        const match = nextModels.find(m => m.id === model.id);
        if (!match) {
          await secureAxios.post('/api/adjustments/models', {
            model_id: model.id,
            period_id: nextPeriod.id,
            classes: model.classes,
            subsidy: model.subsidy
          });
        }

        // Fetch existing adjustments to append
        const existingResponse = await secureAxios.get('/api/adjustments/models', {
          params: { periodId: nextPeriod.id }
        });
        const existingModel = existingResponse.data.models.find(m => m.id === model.id);
        const existingAdjustments = existingModel ? existingModel.adjustments : [];

        // Append new adjustment to next period
        await secureAxios.put(`/api/adjustments/models/${model.id}`, {
          period_id: nextPeriod.id,
          classes: model.classes,
          subsidy: model.subsidy,
          adjustments: [...existingAdjustments, adj]
        });

        // Mark as ghost row in current period
        this.models[index].adjustments[adjIndex].nextPeriod = true;
        this.debounceSave(model.id);
        toast.success(`Adjustment sent to next period: ${nextPeriod.name}`);
        this.actionDialog = false;
      } catch (err) {
        console.error('❌ Error sending to next period:', err);
        toast.error('Failed to send adjustment to next period');
        this.actionDialog = false;
      }
    },
    toggleInsufficientFunds(modelIndex, adjIndex) {
      const model = this.filteredModels[modelIndex];
      const index = this.findModelIndex(model.id);
      if (index === -1) return;
      const adjustment = this.models[index].adjustments[adjIndex];
      adjustment.insufficientFunds = !adjustment.insufficientFunds;
      this.debounceSave(model.id);
      this.actionDialog = false;
    },
    closeDialog() {
      if (this.isPeriodLocked) {
        this.actionDialog = false;
        this.editingAdjustment = {};
        return;
      }
      const model = this.filteredModels[this.selectedModelIndex];
      const index = this.findModelIndex(model.id);
      if (index !== -1 && this.models[index].adjustments[this.selectedAdjIndex]) {
        const currentObs = this.models[index].adjustments[this.selectedAdjIndex].observation;
        const newObs = this.editingAdjustment?.observation || '';
        if (currentObs !== newObs) {
          this.models[index].adjustments[this.selectedAdjIndex].observation = newObs;
          this.debounceSave(model.id); // Autosave observation
        }
      }
      this.actionDialog = false;
      this.editingAdjustment = {};
    },
    setActiveCard(card) {
      this.activeCard = card;
    },
    viewModel() {
      if (this.modelFilter && !this.selectedModels.includes(this.modelFilter)) {
        this.selectedModels.push(this.modelFilter);
        this.modelFilter = null;
      }
    },
    removeModelChip(modelName) {
      this.selectedModels = this.selectedModels.filter(name => name !== modelName);
    },
    viewPeriod() {
      this.fetchModels();
    },
    toggleFilter(filter) {
      if (this.activeFilters.includes(filter)) {
        this.activeFilters = this.activeFilters.filter(f => f !== filter);
      } else {
        this.activeFilters.push(filter);
      }
    },
    sortModels(option) {
      this.sortOption = option;
      switch (option) {
        case 'Full Name A → Z':
          this.models.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
          break;
        case 'Full Name Z → A':
          this.models.sort((a, b) => b.fullName.toLowerCase().localeCompare(a.fullName.toLowerCase()));
          break;
        case 'Stage Name A → Z':
          this.models.sort((a, b) => a.stageName.toLowerCase().localeCompare(b.stageName.toLowerCase()));
          break;
        case 'Stage Name Z → A':
          this.models.sort((a, b) => b.stageName.toLowerCase().localeCompare(a.stageName.toLowerCase()));
          break;
      }
    },
  },
  watch: {
    searchKeyword(newKeyword) {
      if (!newKeyword) {
        this.selectedModels = [];
        return;
      }
      const keyword = newKeyword.toLowerCase();
      const matches = this.models.filter(model =>
        model.adjustments?.some(adj => adj.description.toLowerCase().includes(keyword))
      );
      this.selectedModels = matches.map(m => m.fullName);
      this.activeTab = 'active';
    }
  },
  mounted() {
    this.fetchPeriods();
  }
};
</script>

<style scoped>
.active-card {
  border: 2px solid #1976d2 !important;
}

</style>
   